/** Contacts is one Companies page. Employers and Workspaces stay as the views that host a drilled-in
 *  record (their grants and screens are unchanged); this decides which company types each role can see. */

export const CONTACTS_HUB_DESTINATIONS = ['contacts', 'employers', 'workspaces'] as const;
export type ContactsHubDestination = (typeof CONTACTS_HUB_DESTINATIONS)[number];

// Sub-views that belong to the Workspaces directory but have their own AppView.
const CONTACTS_HUB_SUB_VIEWS = ['client-detail', 'add-workspace', 'user-form', 'request-client'] as const;

export interface ContactsHubRoleFlags {
  role?: string;
  isStaff: boolean;
  isClient: boolean;
  isSupervisor: boolean;
  isSuperAdmin: boolean;
}

export function isContactsHubDestination(value: string): value is ContactsHubDestination {
  return (CONTACTS_HUB_DESTINATIONS as readonly string[]).includes(value);
}

/** True on any view that should light the Contacts entry, list or drilled in. */
export function isContactsHubView(view: string): boolean {
  return isContactsHubDestination(view) || (CONTACTS_HUB_SUB_VIEWS as readonly string[]).includes(view);
}

/** The old rail `show` rules, kept verbatim so grouping never widens access. */
export function contactsHubRoleAllows(id: ContactsHubDestination, flags: ContactsHubRoleFlags): boolean {
  switch (id) {
    case 'contacts': return flags.isStaff || flags.isClient || flags.isSupervisor;
    case 'employers': return flags.isStaff;
    case 'workspaces': return flags.isSuperAdmin || flags.role === 'internal';
  }
}

/** Authorised destinations in display order, from the rows the rail would otherwise have shown. */
export function resolveContactsHubDestinations(
  candidateIds: readonly string[],
  flags: ContactsHubRoleFlags,
): ContactsHubDestination[] {
  return CONTACTS_HUB_DESTINATIONS.filter(id => candidateIds.includes(id) && contactsHubRoleAllows(id, flags));
}
